import React from 'react'
import {
    StyledStaticPageContainer,
    WardenButton,
    StyledWardenParagraph,
    StyledWardenTitle,
} from '../..'

interface OriginUrlValueProps {
    text: string | JSX.Element
    showButton: boolean
    buttonText: string | JSX.Element
}
interface NoOriginUrlValueProps extends OriginUrlValueProps {
    showLoginButton: boolean
}

export interface EmailVerifiedComponentProps {
    onContinueReading: () => void
    onReturnHome: () => void
    onReturnToLogin: () => void
    originUrl: string | undefined
    isLoggedIn: boolean
}

export interface EmailVerifiedVerifiedComponentProps
    extends EmailVerifiedComponentProps {
    showThankYouMessage: boolean
    originUrlValues: OriginUrlValueProps
    noOriginUrlValues: NoOriginUrlValueProps
}

interface GetEmailVerifiedStateComponentProps {
    state: 'already_verified' | 'verified' | 'invalid'
    props: EmailVerifiedComponentProps | EmailVerifiedVerifiedComponentProps
}

// Public accessor for getting the email verified state component
export const GetEmailVerifiedStateComponent = (
    props: GetEmailVerifiedStateComponentProps,
) => {
    switch (props.state) {
        case 'already_verified':
            return AlreadyVerifiedStateComponent(props.props)
        case 'verified':
            return VerifiedStateComponent(
                props.props as EmailVerifiedVerifiedComponentProps,
            )
        case 'invalid':
            return InvalidStateComponent(props.props)
    }
}

const AlreadyVerifiedStateComponent = (props: EmailVerifiedComponentProps) => (
    <StyledStaticPageContainer>
        <StyledWardenTitle>You are already verified.</StyledWardenTitle>
        <StyledWardenParagraph>
            Your email address has already been verified.
            <br />
            <br />
            You have full access to all features including comments and puzzles.
        </StyledWardenParagraph>
        <WardenButton onClick={props.onContinueReading}>
            Continue Reading
        </WardenButton>
    </StyledStaticPageContainer>
)
const VerifiedStateComponent = (props: EmailVerifiedVerifiedComponentProps) => (
    <StyledStaticPageContainer>
        <StyledWardenTitle>You're all set!</StyledWardenTitle>
        {/* Show the thank you message */}
        {props.showThankYouMessage ? (
            <StyledWardenParagraph>
                Thank you for verifying your email.
                <br />
                <br />
            </StyledWardenParagraph>
        ) : null}
        {/* If an originUrl is left, then handle appropriately */}
        {props.originUrl ? (
            <>
                <StyledWardenParagraph>
                    {props.originUrlValues.text}
                </StyledWardenParagraph>
                {/* If we are showing the button, then handle appropriately */}
                {props.originUrlValues.showButton ? (
                    <WardenButton onClick={props.onContinueReading}>
                        {props.originUrlValues.buttonText}
                    </WardenButton>
                ) : null}
            </>
        ) : (
            <>
                {/* There's no originUrl provided, so we want to handle in a different manor to direct them back to the home page */}
                {props.isLoggedIn && props.noOriginUrlValues.showButton ? (
                    <WardenButton onClick={props.onReturnHome}>
                        {props.noOriginUrlValues.buttonText}
                    </WardenButton>
                ) : (
                    <>
                        <StyledWardenParagraph>
                            {props.noOriginUrlValues.text}
                        </StyledWardenParagraph>
                        {props.noOriginUrlValues.showLoginButton ? (
                            <WardenButton onClick={props.onReturnToLogin}>
                                Log In
                            </WardenButton>
                        ) : null}
                    </>
                )}
            </>
        )}
    </StyledStaticPageContainer>
)
const InvalidStateComponent = (props: EmailVerifiedComponentProps) => (
    <StyledStaticPageContainer>
        <StyledWardenTitle>Something went wrong.</StyledWardenTitle>
        <StyledWardenParagraph>
            If you think this is incorrect please report this to the support
            team.
        </StyledWardenParagraph>
        <WardenButton onClick={props.onReturnHome}>Back to Home</WardenButton>
    </StyledStaticPageContainer>
)
